import React from 'react';
import { Row, Col } from "antd";

import ChannelPageEditButton from '../ChannelPageEditButton';
import ProfileStats from '../ProfileStats';
import ProfileSection from '../ProfileSection';

const ChannelProfileSection = ({
  currentChannel, 
  eventsCount, 
  userClaims, 
  subscribersNumber, 
  user,
  subscribeOptions,
  subscriptions,
  setStateHandler
}) => {
  const data = [
    {
      title: 'Events',
      numbers: eventsCount || '0'
    },
    {
      title: 'Contributors',
      numbers: (currentChannel.ownerId && currentChannel.ownerId.length) || '0'
    },
    {
      title: 'Subscribers',
      numbers: subscribersNumber || '0'
    }
  ];

  return (
    <Row className="profile" type="flex" gutter={18}>
      <Col xs={24} md={17}>
        <ProfileSection 
          data={currentChannel}
          additionalContent={
            <div className="profile-button">
              <ChannelPageEditButton 
                currentChannel={currentChannel}
                userClaims={userClaims}
                user={user}
                subscribeOptions={subscribeOptions}
                subscriptions={subscriptions}
                setStateHandler={setStateHandler}
              />
            </div>
          } 
        />
      </Col>
      <Col xs={24} md={7}>
        <ProfileStats 
          data={data}
          type="channel"  
          userType={userClaims.userType} 
        />
      </Col>
    </Row>
  )
}

export default ChannelProfileSection;


// WEBPACK FOOTER //
// ./src/components/Modules/ChannelProfileSection/index.js